"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/stock-order.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fstock-order.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.sideToJSON = exports.sideFromJSON = exports.orderTypeToJSON = exports.orderTypeFromJSON = exports.orderStatusToJSON = exports.orderStatusFromJSON = exports.OrderStatusMessage = exports.Order = exports.OrderHandle = exports.Side = exports.OrderType = exports.OrderStatus = void 0;
const amount_1 = require("./amount");
const round_up_origin_1 = require("./round-up-origin");
const protobufPackage = 'com.step.common.stock.proto';
/**
 * Stock order status
 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["INVALID_ORDER_STATUS"] = "INVALID_ORDER_STATUS";
    OrderStatus["NEW"] = "NEW";
    OrderStatus["PARTIAL_FILL"] = "PARTIAL_FILL";
    OrderStatus["FILLED"] = "FILLED";
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["PENDING_CANCEL"] = "PENDING_CANCEL";
    OrderStatus["REJECTED"] = "REJECTED";
    OrderStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
/**
 * Stock order type
 */
var OrderType;
(function (OrderType) {
    OrderType["INVALID_ORDER_TYPE"] = "INVALID_ORDER_TYPE";
    OrderType["LIMIT"] = "LIMIT";
    OrderType["MARKET"] = "MARKET";
    OrderType["STOP"] = "STOP";
    OrderType["MARKET_IF_TOUCHED"] = "MARKET_IF_TOUCHED";
    OrderType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OrderType || (exports.OrderType = OrderType = {}));
/**
 * Stock order side
 */
var Side;
(function (Side) {
    Side["INVALID_SIDE"] = "INVALID_SIDE";
    Side["BUY"] = "BUY";
    Side["SELL"] = "SELL";
    Side["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Side || (exports.Side = Side = {}));
function createBaseOrderHandle() {
    return { orderId: '', orderNumber: '' };
}
exports.OrderHandle = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
            orderNumber: isSet(object.orderNumber) ? globalThis.String(object.orderNumber) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        if (message.orderNumber !== '') {
            obj.orderNumber = message.orderNumber;
        }
        return obj;
    },
    create(base) {
        return exports.OrderHandle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderHandle();
        message.orderId = object.orderId ?? '';
        message.orderNumber = object.orderNumber ?? '';
        return message;
    },
};
function createBaseOrder() {
    return {
        id: '',
        orderNumber: '',
        symbol: '',
        createdAtMs: '0',
        status: OrderStatus.INVALID_ORDER_STATUS,
        statusMessage: undefined,
        type: OrderType.INVALID_ORDER_TYPE,
        cumulativeQuantity: '',
        orderQuantity: '',
        total: undefined,
        orderTotal: undefined,
        averagePrice: undefined,
        side: Side.INVALID_SIDE,
        fees: undefined,
        lastExecutedAtMs: '0',
        roundUpOrigin: undefined,
    };
}
exports.Order = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            orderNumber: isSet(object.orderNumber) ? globalThis.String(object.orderNumber) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            status: isSet(object.status)
                ? orderStatusFromJSON(object.status)
                : OrderStatus.INVALID_ORDER_STATUS,
            type: isSet(object.type) ? orderTypeFromJSON(object.type) : OrderType.INVALID_ORDER_TYPE,
            cumulativeQuantity: isSet(object.cumulativeQuantity)
                ? globalThis.String(object.cumulativeQuantity)
                : '',
            orderQuantity: isSet(object.orderQuantity) ? globalThis.String(object.orderQuantity) : '',
            side: isSet(object.side) ? sideFromJSON(object.side) : Side.INVALID_SIDE,
        };
        if (isSet(object.statusMessage)) {
            message.statusMessage = exports.OrderStatusMessage.fromJSON(object.statusMessage);
        }
        if (isSet(object.total)) {
            message.total = amount_1.Amount.fromJSON(object.total);
        }
        if (isSet(object.orderTotal)) {
            message.orderTotal = amount_1.Amount.fromJSON(object.orderTotal);
        }
        if (isSet(object.averagePrice)) {
            message.averagePrice = amount_1.Amount.fromJSON(object.averagePrice);
        }
        if (isSet(object.fees)) {
            message.fees = amount_1.Amount.fromJSON(object.fees);
        }
        if (isSet(object.lastExecutedAtMs)) {
            message.lastExecutedAtMs = globalThis.String(object.lastExecutedAtMs);
        }
        if (isSet(object.roundUpOrigin)) {
            message.roundUpOrigin = round_up_origin_1.RoundUpOrigin.fromJSON(object.roundUpOrigin);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.orderNumber !== '') {
            obj.orderNumber = message.orderNumber;
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.status !== OrderStatus.INVALID_ORDER_STATUS) {
            obj.status = orderStatusToJSON(message.status);
        }
        if (message.statusMessage !== undefined) {
            obj.statusMessage = exports.OrderStatusMessage.toJSON(message.statusMessage);
        }
        if (message.type !== OrderType.INVALID_ORDER_TYPE) {
            obj.type = orderTypeToJSON(message.type);
        }
        if (message.cumulativeQuantity !== '') {
            obj.cumulativeQuantity = message.cumulativeQuantity;
        }
        if (message.orderQuantity !== '') {
            obj.orderQuantity = message.orderQuantity;
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        if (message.orderTotal !== undefined) {
            obj.orderTotal = amount_1.Amount.toJSON(message.orderTotal);
        }
        if (message.averagePrice !== undefined) {
            obj.averagePrice = amount_1.Amount.toJSON(message.averagePrice);
        }
        if (message.side !== Side.INVALID_SIDE) {
            obj.side = sideToJSON(message.side);
        }
        if (message.fees !== undefined) {
            obj.fees = amount_1.Amount.toJSON(message.fees);
        }
        if (message.lastExecutedAtMs !== undefined && message.lastExecutedAtMs !== '0') {
            obj.lastExecutedAtMs = message.lastExecutedAtMs;
        }
        if (message.roundUpOrigin !== undefined) {
            obj.roundUpOrigin = round_up_origin_1.RoundUpOrigin.toJSON(message.roundUpOrigin);
        }
        return obj;
    },
    create(base) {
        return exports.Order.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrder();
        message.id = object.id ?? '';
        message.orderNumber = object.orderNumber ?? '';
        message.symbol = object.symbol ?? '';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.status = object.status ?? OrderStatus.INVALID_ORDER_STATUS;
        message.statusMessage = (object.statusMessage !== undefined && object.statusMessage !== null)
            ? exports.OrderStatusMessage.fromPartial(object.statusMessage)
            : undefined;
        message.type = object.type ?? OrderType.INVALID_ORDER_TYPE;
        message.cumulativeQuantity = object.cumulativeQuantity ?? '';
        message.orderQuantity = object.orderQuantity ?? '';
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : undefined;
        message.orderTotal = (object.orderTotal !== undefined && object.orderTotal !== null)
            ? amount_1.Amount.fromPartial(object.orderTotal)
            : undefined;
        message.averagePrice = (object.averagePrice !== undefined && object.averagePrice !== null)
            ? amount_1.Amount.fromPartial(object.averagePrice)
            : undefined;
        message.side = object.side ?? Side.INVALID_SIDE;
        message.fees = (object.fees !== undefined && object.fees !== null)
            ? amount_1.Amount.fromPartial(object.fees)
            : undefined;
        message.lastExecutedAtMs = object.lastExecutedAtMs ?? '0';
        message.roundUpOrigin = (object.roundUpOrigin !== undefined && object.roundUpOrigin !== null)
            ? round_up_origin_1.RoundUpOrigin.fromPartial(object.roundUpOrigin)
            : undefined;
        return message;
    },
};
function createBaseOrderStatusMessage() {
    return { message: '' };
}
exports.OrderStatusMessage = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.message)) {
            message.message = globalThis.String(object.message);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined && message.message !== '') {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.OrderStatusMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOrderStatusMessage();
        message.message = object.message ?? '';
        return message;
    },
};
function orderStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ORDER_STATUS':
            return OrderStatus.INVALID_ORDER_STATUS;
        case 1:
        case 'NEW':
            return OrderStatus.NEW;
        case 2:
        case 'PARTIAL_FILL':
            return OrderStatus.PARTIAL_FILL;
        case 3:
        case 'FILLED':
            return OrderStatus.FILLED;
        case 4:
        case 'CANCELED':
            return OrderStatus.CANCELED;
        case 5:
        case 'PENDING_CANCEL':
            return OrderStatus.PENDING_CANCEL;
        case 6:
        case 'REJECTED':
            return OrderStatus.REJECTED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return OrderStatus.UNRECOGNIZED;
    }
}
exports.orderStatusFromJSON = orderStatusFromJSON;
function orderStatusToJSON(object) {
    switch (object) {
        case OrderStatus.INVALID_ORDER_STATUS:
            return 'INVALID_ORDER_STATUS';
        case OrderStatus.NEW:
            return 'NEW';
        case OrderStatus.PARTIAL_FILL:
            return 'PARTIAL_FILL';
        case OrderStatus.FILLED:
            return 'FILLED';
        case OrderStatus.CANCELED:
            return 'CANCELED';
        case OrderStatus.PENDING_CANCEL:
            return 'PENDING_CANCEL';
        case OrderStatus.REJECTED:
            return 'REJECTED';
        case OrderStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.orderStatusToJSON = orderStatusToJSON;
function orderTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ORDER_TYPE':
            return OrderType.INVALID_ORDER_TYPE;
        case 1:
        case 'LIMIT':
            return OrderType.LIMIT;
        case 2:
        case 'MARKET':
            return OrderType.MARKET;
        case 3:
        case 'STOP':
            return OrderType.STOP;
        case 4:
        case 'MARKET_IF_TOUCHED':
            return OrderType.MARKET_IF_TOUCHED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return OrderType.UNRECOGNIZED;
    }
}
exports.orderTypeFromJSON = orderTypeFromJSON;
function orderTypeToJSON(object) {
    switch (object) {
        case OrderType.INVALID_ORDER_TYPE:
            return 'INVALID_ORDER_TYPE';
        case OrderType.LIMIT:
            return 'LIMIT';
        case OrderType.MARKET:
            return 'MARKET';
        case OrderType.STOP:
            return 'STOP';
        case OrderType.MARKET_IF_TOUCHED:
            return 'MARKET_IF_TOUCHED';
        case OrderType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.orderTypeToJSON = orderTypeToJSON;
function sideFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SIDE':
            return Side.INVALID_SIDE;
        case 1:
        case 'BUY':
            return Side.BUY;
        case 2:
        case 'SELL':
            return Side.SELL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Side.UNRECOGNIZED;
    }
}
exports.sideFromJSON = sideFromJSON;
function sideToJSON(object) {
    switch (object) {
        case Side.INVALID_SIDE:
            return 'INVALID_SIDE';
        case Side.BUY:
            return 'BUY';
        case Side.SELL:
            return 'SELL';
        case Side.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.sideToJSON = sideToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock-order.js.map